import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { PressKitSection } from '@modules/content-api/adapter/press-kit.adapter';
import { ActionIcons, ButtonItem } from '@modules/ui/action-container/action-container.component';

import { SectionDefaultsComponent } from '../section-defaults';

@Component({
  selector: 'mb-press-kit-section',
  templateUrl: './press-kit-section.component.html',
  styleUrls: ['./press-kit-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PressKitSectionComponent extends SectionDefaultsComponent {
  public defaultActions: ButtonItem[] = [
    {
      icon: ActionIcons.SHARE,
      class: 'btn btn-plain d-none d-sm-inline-flex',
    },
    {
      icon: ActionIcons.DOWNLOAD,
      class: 'btn btn-plain d-none d-sm-inline-flex',
    },
    {
      icon: ActionIcons.BOOKMARK,
      class: 'btn btn-plain',
    },
  ];

  @Input() pressKitSection!: PressKitSection;
}
